import {DotPadSendModule, RefreshMode} from "./DotPadSendModule";

class DotpadSDK {  // eslint-disable-line no-unused-vars
    constructor(dotPad) {
        this.dotPad = dotPad
        this.dotPadSendModule = new DotPadSendModule(dotPad)

        // 해상도 의존 값은 여기서 만들지 않는다
        this.DOT_PAD_INFO = null

        this.VOXEL_ROW_NUM = 0
        this.VOXEL_COL_NUM = 0
        this.cellTotal = 0
        this.halfWidth = 0

        this.dot_Matrix_All = null
        this.dtm_Data = null

        this.length = 10     // cell row count
        this.numCell = 30    // cell col count
        this.LINE_HEIGHT = 0

        this.writeString = ""
        this.isRunning = false

        if (dotPad) {
            this.dotPadSendModule.addDotPadLine(this.length, this.numCell)
            dotPad.setDotPadSendModule(this.dotPadSendModule)
        }
    }

    /**
     캔버스 정보가 고정값(40, 60 -> 64, 90 등)이 였던 것을 닷패드 정보에 따라 변경
     - param dotPadInfo{cellTotal, height, width}
     */
    setDotPadSDKInfo(dotPadInfo) {
        /*
          dotPadInfo = {
            width: 60 | 96 | 180,
            height: 40 | 64 | 240
          }
        */
        if (!dotPadInfo) return
        this.DOT_PAD_INFO = dotPadInfo
        let { width, height } = dotPadInfo

        /* 8pin 고정 해제 및 8핀에 맞게 나누어 떨어지는 숫자로 변환 */
        if (width % 2 !== 0 || height % 4 !== 0) {
            // throw new Error("Invalid dotpad resolution")
            width = Math.ceil(width / 2) * 2
            height = Math.ceil(height / 4) * 4
        }

        if (width % 2 !== 0 || height % 4 !== 0) {
            throw new Error("Invalid dotpad resolution")
        }

        this.VOXEL_COL_NUM = width
        this.VOXEL_ROW_NUM = height

        this.halfWidth = width / 2
        this.LINE_HEIGHT = height / 4

        this.cellsPerLine = Math.floor(dotPadInfo.totalCellWidth ?? dotPadInfo.width / 3)

        this.cellTotal = this.halfWidth * this.LINE_HEIGHT

        // 🔥 완전 재초기화
        this.dot_Matrix_All = this.create2DArray(height, width)
        this.dtm_Data = new Uint8Array(this.cellTotal)

        this.length = this.LINE_HEIGHT
        this.numCell = this.halfWidth

        if (this.dotPad) {
            this.dotPadSendModule.addDotPadLine(this.length, this.numCell)
            this.dotPad.setDotPadSendModule(this.dotPadSendModule)
        }
    }

    create2DArray(rows, cols) {
        return Array.from({ length: rows }, () =>
            new Uint8Array(cols)
        )
    }

    toHexString(byteArray) {
        return Array.from(byteArray)
            .map(b => b.toString(16).padStart(2, "0"))
            .join("")
    }

    hexToBytes(hex) {
        const bytes = new Uint8Array(hex.length / 2)
        for (let i = 0; i < hex.length; i += 2) {
            bytes[i / 2] = parseInt(hex.substr(i, 2), 16)
        }
        return bytes
    }

    /**
     * Convert a hex string to an ArrayBuffer.
     *
     * @param {string} hexString - hex representation of bytes
     * @return {ArrayBuffer} - The bytes in an ArrayBuffer.
     */
    hexStringToArrayBuffer(hexString) {
        // remove the leading 0x
        hexString = hexString.replace(/^0x/, '');

        // ensure even number of characters
        if (hexString.length % 2 !== 0) {
            console.log('WARNING: expecting an even number of characters in the hexString');
        }

        // check for some non-hex characters
        var bad = hexString.match(/[G-Z\s]/i);
        if (bad) {
            console.log('WARNING: found non-hex characters', bad);
        }

        // split the string into pairs of octets
        var pairs = hexString.match(/[\dA-F]{2}/gi);

        // convert the octets to integers
        var integers = pairs.map(function (s) {
            return parseInt(s, 16);
        });

        var array = new Uint8Array(integers);
        // console.log(array);

        return array.buffer;
    }

    /**
     * Converts a 600-character hex string to an array of 2400 Boolean values.
     *
     * @param { string } hexString - A 600-character hex string (1 hex = 4 bits).
     * @return { boolean[] } - An array of 2400 Boolean values.
     */
    hexToBooleanArray = (hexString) => {
        const byteArray = this.hexToBytes(hexString) //byteArray length는 닷 패드 설정에 따라 300, 768 셀로 나뉨
        const booleanArray = new Array(byteArray.length * 8).fill(false)

        //todo: a4 대응 사이즈 필요
        const canvasWidth = byteArray.length === 300
            ? 60
            : 96
        const canvasWidthHalf = byteArray.length === 300
            ? 30
            : 48

        for (let i = 0; i < byteArray.length; i++) {
            const startIndex = Math.floor(i / canvasWidthHalf) * canvasWidth * 4 + (i % canvasWidthHalf) * 2
            for (let bit = 0; bit < 8; bit++) {
                const index = startIndex + (bit % 4) * canvasWidth + Math.floor(bit / 4)
                booleanArray[index] = !!(byteArray[i] & (1 << bit))
            }
        }
        return booleanArray
    }

    checksum(test_data) {
        let check = 0xA5
        for (let i = 0; i < test_data.length; i++) {
            check = check ^ test_data[i]
        }
        return ('0' + (check & 0xFF).toString(16)).slice(-2)
    }

    /**
     Make a Data set using Application's Canvas Data(voxels: Array<Array<Bool>>).
     - warning: None.
     - parameter deviceType: DeviceType
     - parameter voxels: Array<Array<Bool>>
     - returns:
     */
    Load_mapFile(voxels) {
        let order = 0
        for (let i = 0; i < this.VOXEL_ROW_NUM; i++) {
            for (let j = 0; j < this.VOXEL_COL_NUM; j++) {
                if (Boolean(voxels[order])) {
                    this.dot_Matrix_All[i][j] = 0x01
                } else {
                    this.dot_Matrix_All[i][j] = 0x00
                }
                order++;
            }
        }
    }

    /**
     Make a One Cell Data.
     - warning: None.
     - parameter cell_ID: Int
     - returns: None
     */
    Sub_dot_Cell_Matrix(cell_ID) {
        const halfWidth = this.DOT_PAD_INFO.halfWidth
        const startIndex = parseInt(cell_ID / halfWidth)
        const endIndex = parseInt(cell_ID % halfWidth)

        let _dot_Cell = this.create2DArray(4, 2)
        _dot_Cell[0][0] = this.dot_Matrix_All[startIndex * 4][endIndex * 2]
        _dot_Cell[0][1] = this.dot_Matrix_All[startIndex * 4][endIndex * 2 + 1]
        _dot_Cell[1][0] = this.dot_Matrix_All[startIndex * 4 + 1][endIndex * 2]
        _dot_Cell[1][1] = this.dot_Matrix_All[startIndex * 4 + 1][endIndex * 2 + 1]

        _dot_Cell[2][0] = this.dot_Matrix_All[startIndex * 4 + 2][endIndex * 2]
        _dot_Cell[2][1] = this.dot_Matrix_All[startIndex * 4 + 2][endIndex * 2 + 1]
        _dot_Cell[3][0] = this.dot_Matrix_All[startIndex * 4 + 3][endIndex * 2]
        _dot_Cell[3][1] = this.dot_Matrix_All[startIndex * 4 + 3][endIndex * 2 + 1]

        return _dot_Cell
    }

    /**
     Transform One Cell Data to Byte Value.
     - warning: None.
     - parameter sub_Cell: [[UInt8]]
     - returns: [[UInt8]]
     */
    Get_dot_Cell_Byte(sub_Cell) {
        let b = 0;

        b |= (sub_Cell[0][0] & 1) << 0;
        b |= (sub_Cell[1][0] & 1) << 1;
        b |= (sub_Cell[2][0] & 1) << 2;
        b |= (sub_Cell[3][0] & 1) << 3;

        b |= (sub_Cell[0][1] & 1) << 4;
        b |= (sub_Cell[1][1] & 1) << 5;
        b |= (sub_Cell[2][1] & 1) << 6;
        b |= (sub_Cell[3][1] & 1) << 7;

        return b;
    }
    /**
     DTM PREFIX 포멧 없이 DTM 파일 생성
     */
    Make_DTM_Data() {
        for (let cellId = 0; cellId < this.cellTotal; cellId++) {
            const cell = this.Sub_dot_Cell_Matrix(cellId)
            this.dtm_Data[cellId] = this.Get_dot_Cell_Byte(cell)
        }

        this.writeString = this.toHexString(this.dtm_Data)
    }

    /**
     Send Data of Application's Canvas Data to dotPad_Communication.
     - warning: None.
     - parameter
     - returns: None.
     */
    async sendPixelPattern() {
        await this.sendMessage(this.writeString)
    }

    /**
     * Sends data to the DotPad display graphic area through the `dotPad_Communication`.
     *
     * @async
     * @param { string } writeString
     * @param { "GRAPHIC" | "TEXT" } mode
     * @returns { Promise<void> }
     */
    async sendMessage(writeString, mode = "GRAPHIC") { // eslint-disable-line no-unused-vars
        this.stringwithPadding = writeString

        if (!this.stringwithPadding) return
        if (this.stringwithPadding.length !== this.length * this.numCell * 2) return

        const isCompleted = this.dotPadSendModule.getDisplayComplete()
        if (isCompleted) {
            for (let i = 1; i <= this.length; i++) {
                this.setLineDiff(i, mode)
            }
            await this.dotPadSendModule.sendCommand()

            // 1초 지연
            await new Promise(resolve => setTimeout(resolve, 1000))
        }
        else {
            setTimeout(() => {
                this.sendMessage(this.stringwithPadding, mode)
            }, 1000)
        }
    }

    async sendMessageDiff(writeString, mode = "GRAPHIC", complete = false) { // eslint-disable-line no-unused-vars
        this.stringwithPadding = writeString

        if (!this.stringwithPadding) return
        if (this.stringwithPadding.length !== this.length * this.numCell * 2) return
        if (this.isRunning) return

        let sendReady = false
        for (let i = 1; i <= this.length; i++) {
            if (this.setLineDiff(i, mode, complete)) {
                sendReady = true
            }
        }

        if (sendReady) {
            if (!complete || !this.dotPadSendModule.getIsFunctionRunning() || this.dotPad.deviceInfo.cellType === "D3") {
                await this.dotPadSendModule.sendCommand();
            }
        } else {
            this.dotPadSendModule.setRefreshMode(RefreshMode.NONE)
        }
    }

    async sendText(textString, index) {
        if (parseInt(this.dotPad.deviceInfo.colCellSize) === 48) return
        if (textString.length < 1) return

        let maxIndex = Math.ceil(textString.length / 40)
        this.SubString = index === (maxIndex - 1)
            ? textString.substring(index * 20 * 2)
            : textString.substring(index * 20 * 2, (index + 1) * 20 * 2)

        if (this.dotPad != null && this.dotPad.connected) {
            this.dotPadSendModule.setRefreshMode(RefreshMode.TEXT_DISPLAY)
            this.dotPadSendModule.setDotPadLineCommand(0, "80", "00", this.SubString)
            await this.dotPadSendModule.sendCommand()

            return true
        }
    }

    setText(textString, index) {
        if (parseInt(this.dotPad.deviceInfo.colCellSize) === 48) return
        if (textString.length < 1) return

        let maxIndex = Math.ceil(textString.length / 40)
        this.SubString = index === (maxIndex - 1)
            ? textString.substring(index * 20 * 2)
            : textString.substring(index * 20 * 2, (index + 1) * 20 * 2)

        if (this.dotPad != null && this.dotPad.connected) {
            this.dotPadSendModule.setRefreshMode(RefreshMode.TEXT_DISPLAY)
            this.dotPadSendModule.setDotPadLineCommand(0, "80", "00", this.SubString)

            return true
        }
    }

    downAllCell() {
        this.setText("00".repeat(20), 0);
        this.sendMessage("00".repeat(300));
    }

    /**
     * @param brailleText
     * @returns {string}
     */
    convertGraphicToTextHex(brailleText) {
        const splitStrings = this.hexToBinary(brailleText).match(/.{1,8}/g);
        const swappedStrings = splitStrings.map((subStr, index) => {
            const pin1 = subStr.substring(7, 8);
            const pin2 = subStr.substring(6, 7);
            const pin3 = subStr.substring(5, 6);
            const pin4 = subStr.substring(4, 5);
            const pin5 = subStr.substring(3, 4);
            const pin6 = subStr.substring(2, 3);
            const pin7 = subStr.substring(1, 2);
            const pin8 = subStr.substring(0, 1);

            return pin8 + pin4 + pin7 + pin6 + pin5 + pin3 + pin2 + pin1;
        });
        // 3. 조인하고 다시 16진수로 변환
        return this.binaryToHex(swappedStrings.join(""));
    }

    /**
     * @param tactileLetters
     * @param {number} numberOfPins
     * @returns {string}
     */
    changeTactileLettersGraphicDisplayText(brailleText) {
        const splitStrings = this.hexToBinary(brailleText).match(/.{1,8}/g);
        const swappedStrings = splitStrings.map((subStr) => {
            return subStr.substring(0, 1) + subStr.substring(2, 5) + subStr.substring(1, 2) + subStr.substring(5);
        });
        // 3. 조인하고 다시 16진수로 변환
        return this.binaryToHex(swappedStrings.join(""));
    }

    hexToBinary(hex) {
        let binary = "";
        for (let i = 0; i < hex.length; i++) {
            const decimal = parseInt(hex[i], 16);
            const fourBits = decimal.toString(2).padStart(4, "0");
            binary += fourBits;
        }
        return binary;
    }

    binaryToHex(binary) {
        let hex = "";
        let i = 0;
        while (i < binary.length) {
            const fourBits = binary.substring(i, i + 4);
            const decimal = parseInt(fourBits, 2);
            hex += decimal.toString(16).toUpperCase();
            i += 4;
        }
        return hex;
    }

    /**
     * @param brailleText
     * @param {number} numberOfPins // 6 dot / 8 dot
     * @param {array} drawPoints
     * @param {number} [letterSpacing] // 0: no spacing, 1: spacing
     * @returns {string}
     */
    changeGraphicDisplayMultiline(brailleText, numberOfPins, drawPoints, letterSpacing = 1) {
        const splitStrings = this.hexToBinary(brailleText).match(/.{1,8}/g);
        this.lineCount = 0;
        const effectiveLineHeight = letterSpacing === 0 ? Math.round(this.cellsPerLine * 1.5) : this.cellsPerLine;
        let tempDotCellLineData = this.createTempDotCellLineData(splitStrings, numberOfPins, letterSpacing, effectiveLineHeight);
        let dotCellLineData = [];
        const drawPointHandlers = {
            '0000': this.handle0000.bind(this),
            '0001': this.handle0001.bind(this),
            '0011': this.handle0011.bind(this),
            '0111': this.handle0111.bind(this),
            '1000': this.handle1000.bind(this),
            '1001': this.handle1001.bind(this),
            '1011': this.handle1011.bind(this),
            '1100': this.handle1100.bind(this),
            '1101': this.handle1101.bind(this),
            '1110': this.handle1110.bind(this),
            '1111': this.handle1111.bind(this),
        }

        drawPoints.forEach((drawPointArr) => {
            let drawPoint = drawPointArr.join().replaceAll(',', '');
            if (drawPointHandlers[drawPoint]) {
                drawPointHandlers[drawPoint](tempDotCellLineData, dotCellLineData, numberOfPins);
            }
        });

        // 3. 조인하고 다시 16진수로 변환
        return this.binaryToHex(dotCellLineData.join(""));
    }

    /**
     * Before applying dot cell data blank
     * @param {array} splitStrings
     * @param {number} numberOfPins
     * @param {number} [letterSpacing]
     * @param {number} [lineHeight]
     * @returns {array}
     */
    createTempDotCellLineData(splitStrings, numberOfPins, letterSpacing = 1, lineHeight = null) {
        const effectiveLineHeight = lineHeight ?? this.LINE_HEIGHT;
        let dotCellLineData = [];
        let rearrangeBits = [];
        const padLineToNumCell = (line) => {
            while (line.length < this.numCell) {
                line.push("00000000");
            }
            return line;
        };
        splitStrings.forEach((subStr, index) => {
            const localIndex = index % effectiveLineHeight;
            const tempRearrangeBits = this.rearrangeBits(subStr, numberOfPins, localIndex, rearrangeBits, letterSpacing);

            if ((index + 1) % effectiveLineHeight == 0) {
                dotCellLineData.push(padLineToNumCell(tempRearrangeBits));
                rearrangeBits = [];
            }
        });

        if (rearrangeBits.length > 0) {
            dotCellLineData.push(padLineToNumCell(rearrangeBits));
        }

        return dotCellLineData;
    }

    /**
     * rearrange the bit
     * @param {string} subStr
     * @param {number} numberOfPins
     * @param {number} index
     * @param {array} rearrangeBits
     * @param {number} [letterSpacing]
     * @returns {rearrangeBits}
     */
    rearrangeBits(subStr, numberOfPins, index, rearrangeBits, letterSpacing = 1) {
        // 1. 짝수 번째 텍스트 7, 8번 핀을 제외한 3비트씩 앞뒤로 위치를 바꾸고 8비트만큼 "0"으로 채움(6점식)
        //    짝수 번째 텍스트 7, 8번 핀을 포함한 3비트씩 앞뒤로 위치를 바꾸고 8비트만큼 "0"으로 채움(8점식)
        const number7Pin = numberOfPins === this.DOT_CELL_PIN ? subStr.substring(0, 1) : "0";
        const number8Pin = numberOfPins === this.DOT_CELL_PIN ? subStr.substring(1, 2) : "0";
        const bitsFromPins1To3 = subStr.substring(2, 5);
        const bitsFromPins4To6 = subStr.substring(5);
        if (letterSpacing !== 0 && index % 2 === 1) {
            rearrangeBits.push(number8Pin + bitsFromPins4To6 + "0000");
            rearrangeBits.push("0000" + number7Pin + bitsFromPins1To3);
        } else {
            rearrangeBits.push(number7Pin + bitsFromPins1To3 + number8Pin + bitsFromPins4To6);
        }

        return rearrangeBits;
    }

    handle0000(dotCellLineData) {
        let tempData = [];
        for (let i = 0; i < this.numCell; i++) {
            tempData.push("00000000");
        }
        dotCellLineData.push(tempData);
    }

    handle1111(tempDotCellLineData, dotCellLineData) {
        if (tempDotCellLineData[this.lineCount]) {
            tempDotCellLineData[this.lineCount].forEach(data => {
                dotCellLineData.push(data);
            });
        }
        this.lineCount++;
    }

    handle0001(tempDotCellLineData, dotCellLineData) {
        if (tempDotCellLineData[this.lineCount]) {
            tempDotCellLineData[this.lineCount].forEach(data => {
                dotCellLineData.push(data.substring(3, 4) + "000" + data.substring(7, 8) + "000");
            });
        }
    }

    handle0011(tempDotCellLineData, dotCellLineData) {
        if (tempDotCellLineData[this.lineCount]) {
            tempDotCellLineData[this.lineCount].forEach(data => {
                dotCellLineData.push(data.substring(2, 4) + "00" + data.substring(6, 8) + "00");
            });
        }
    }

    handle0111(tempDotCellLineData, dotCellLineData, numberOfPins) {
        if (tempDotCellLineData[this.lineCount]) {
            tempDotCellLineData[this.lineCount].forEach(data => {
                dotCellLineData.push(data.substring(1, 4) + "0" + data.substring(5, 8) + "0");
            });
        }
        if (numberOfPins != this.DOT_CELL_PIN) {
            this.lineCount++;
        }
    }

    handle1000(tempDotCellLineData, dotCellLineData, numberOfPins) {
        if (numberOfPins != this.DOT_CELL_PIN) {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("000" + data.substring(1, 2) + "000" + data.substring(5, 6));
                });
            }
        } else {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("000" + data.substring(0, 1) + "000" + data.substring(4, 5));
                });
            }
        }
        this.lineCount++;
    }

    handle1001(tempDotCellLineData, dotCellLineData, numberOfPins) {
        if (tempDotCellLineData[this.lineCount]) {
            let tempData1 = [], tempData2 = [], tempData3 = [], tempData4 = [];
            if (numberOfPins != this.DOT_CELL_PIN) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    tempData1.push(data.substring(1, 2));
                    tempData2.push(data.substring(5, 6));
                });
            } else {
                if (tempDotCellLineData[this.lineCount]) {
                    tempDotCellLineData[this.lineCount].forEach(data => {
                        tempData1.push(data.substring(0, 1));
                        tempData2.push(data.substring(4, 5));
                    });
                }
            }
            if (tempDotCellLineData[this.lineCount + 1]) {
                tempDotCellLineData[this.lineCount + 1].forEach(data => {
                    tempData3.push(data.substring(3, 4) + "00");
                    tempData4.push(data.substring(7, 8) + "00");
                });
            } else {
                tempDotCellLineData[this.lineCount].forEach(() => {
                    tempData3.push("000");
                    tempData4.push("000");
                });
            }
            tempData1.forEach((data, i) => {
                dotCellLineData.push(tempData3[i] + data + tempData4[i] + tempData2[i]);
            });
        }
        this.lineCount++;
    }

    handle1011(tempDotCellLineData, dotCellLineData) {
        if (tempDotCellLineData[this.lineCount]) {
            let tempData1 = [], tempData2 = [], tempData3 = [], tempData4 = [];
            tempDotCellLineData[this.lineCount].forEach(data => {
                tempData1.push(data.substring(0, 1));
                tempData2.push(data.substring(4, 5));
            });
            if (tempDotCellLineData[this.lineCount + 1]) {
                tempDotCellLineData[this.lineCount + 1].forEach(data => {
                    tempData3.push(data.substring(2, 4) + "0");
                    tempData4.push(data.substring(6, 8) + "0");
                });
            } else {
                tempDotCellLineData[this.lineCount].forEach(() => {
                    tempData3.push("000");
                    tempData4.push("000");
                });
            }
            tempData1.forEach((data, i) => {
                dotCellLineData.push(tempData3[i] + data + tempData4[i] + tempData2[i]);
            });
        }
        this.lineCount++;
    }

    handle1100(tempDotCellLineData, dotCellLineData, numberOfPins) {
        if (numberOfPins != this.DOT_CELL_PIN) {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("00" + data.substring(1, 3) + "00" + data.substring(5, 7));
                });
            }
        } else {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("00" + data.substring(0, 2) + "00" + data.substring(4, 6));
                });
            }
        }
        this.lineCount++;
    }

    handle1101(tempDotCellLineData, dotCellLineData) {
        if (tempDotCellLineData[this.lineCount]) {
            let tempData1 = [], tempData2 = [], tempData3 = [], tempData4 = [];
            tempDotCellLineData[this.lineCount].forEach(data => {
                tempData1.push(data.substring(0, 2));
                tempData2.push(data.substring(4, 6));
            });
            if (tempDotCellLineData[this.lineCount + 1]) {
                tempDotCellLineData[this.lineCount + 1].forEach(data => {
                    tempData3.push(data.substring(3, 4) + "0");
                    tempData4.push(data.substring(7, 8) + "0");
                });
            } else {
                tempDotCellLineData[this.lineCount].forEach(() => {
                    tempData3.push("000");
                    tempData4.push("000");
                });
            }
            tempData1.forEach((data, i) => {
                dotCellLineData.push(tempData3[i] + data + tempData4[i] + tempData2[i]);
            });
        }
        this.lineCount++;
    }

    handle1110(tempDotCellLineData, dotCellLineData, numberOfPins) {
        if (numberOfPins != this.DOT_CELL_PIN) {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("0" + data.substring(1, 4) + "0" + data.substring(5, 8));
                });
            }
        } else {
            if (tempDotCellLineData[this.lineCount]) {
                tempDotCellLineData[this.lineCount].forEach(data => {
                    dotCellLineData.push("0" + data.substring(0, 3) + "0" + data.substring(4, 7));
                });
            }
        }
        this.lineCount++;
    }

    setLineDiff(i, mode, complete = false) {
        const commandCode = mode === "GRAPHIC" ? "00" : "80"
        const step = i - 1

        this.SubString = this.stringwithPadding.substring(step * this.numCell * 2, ((step + 1) * this.numCell * 2))
        if (complete) {
            this.dotPadSendModule.setRefreshMode(RefreshMode.LIVE_DISPLAY)
        } else {
            this.dotPadSendModule.setRefreshMode(RefreshMode.GRAPHIC_DISPLAY)
        }
        return this.dotPadSendModule.setDotPadLineCommandDiff(i, commandCode, this.SubString, !complete)
    }

    convertPixelToDotCell(pixel) {
        let dotCellLineData = [];
        const width = this.VOXEL_COL_NUM;
        const height = this.VOXEL_ROW_NUM;
        const numWidthDot = 2;  // 가로 2개씩 묶음
        const numHeightDot = 4; // 세로 4개씩 묶음

        for (let i = 0; i < height; i += numHeightDot) {
            for (let j = 0; j < width; j += numWidthDot) {
                let byte = 0x00;

                // 1차원 배열에서의 인덱스 계산: row * VOXEL_COL_NUM + col
                if (i < height && j < width && pixel[i * width + j]) byte |= 0x01;
                if ((i+1) < height && j < width && pixel[(i+1) * width + j]) byte |= 0x02;
                if ((i+2) < height && j < width && pixel[(i+2) * width + j]) byte |= 0x04;
                if ((i+3) < height && j < width && pixel[(i+3) * width + j]) byte |= 0x08;
                if (i < height && (j+1) < width && pixel[i * width + (j+1)]) byte |= 0x10;
                if ((i+1) < height && (j+1) < width && pixel[(i+1) * width + (j+1)]) byte |= 0x20;
                if ((i+2) < height && (j+1) < width && pixel[(i+2) * width + (j+1)]) byte |= 0x40;
                if ((i+3) < height && (j+1) < width && pixel[(i+3) * width + (j+1)]) byte |= 0x80;

                dotCellLineData.push(byte);
            }
        }

        // 바이트 배열을 16진수 문자열로 변환
        return dotCellLineData.map(byte => byte.toString(16).padStart(2, '0')).join('').toUpperCase();
    }
}

export { DotpadSDK }
